import { FC } from 'react'

import { PermissionsGate, PermissionsGateProps } from '@revolut-internal/idave-web-auth'

import { AppPermissionsMap, RTM_SERVICE_NAME, RtmPermission } from 'common/auth/auth'

type RtmPermissionsGateProps = Omit<
  PermissionsGateProps<AppPermissionsMap>,
  'permissions'
> & {
  permissions: RtmPermission[]
}

export const RtmPermissionsGate: FC<RtmPermissionsGateProps> = ({
  permissions,
  matchType = 'all',
  variant = 'widget',
  children,
  ...restProps
}) => {
  return (
    <PermissionsGate<AppPermissionsMap>
      permissions={permissions.map(permission => ({
        service: RTM_SERVICE_NAME,
        value: permission,
      }))}
      matchType={matchType}
      variant={variant}
      {...restProps}
    >
      {children}
    </PermissionsGate>
  )
}
